const initialState = {
  isFetching: false,
  isFetched: false,
  success: false,
  error: false,
  data: {},
  origin: [],
  destination: [],
  selectedOrigin: null,
  selectedDest: null,
  selectedSecurity: {
    avaliableQuantity: 0,
    inAnaliseQuantity: 0,
    key: '',
    securityId: '',
    securityName: '',
    securityValue: 0,
    unitPrice: 0,
    value: ''
  },
  selectedQuantitySecurity: 0,
  errors: [],
  rentContract: '',
  marginContract: '',
  securityTransferItems: [],
  eletronicSignature: ''
}

export const ACTION_TYPES = {
  TRANSFER_SECURITY_REQUEST: 'TRANSFER_SECURITY_REQUEST',
  TRANSFER_SECURITY_SUCCESS: 'TRANSFER_SECURITY_SUCCESS',
  TRANSFER_SECURITY_ERROR: 'TRANSFER_SECURITY_ERROR',

  TRANSFER_SECURITY_SELECT_ORIGIN: 'TRANSFER_SECURITY_SELECT_ORIGIN',
  TRANSFER_SECURITY_SELECT_DEST: 'TRANSFER_SECURITY_SELECT_DEST',
  TRANSFER_SECURITY_SELECT_SECURITY: 'TRANSFER_SECURITY_SELECT_SECURITY',
  TRANSFER_SECURITY_SELECT_QUANTITY_SECURITY: 'TRANSFER_SECURITY_SELECT_QUANTITY_SECURITY',
  TRANSFER_SECURITY_SELECTED_SECURITY_ITEMS: 'TRANSFER_SECURITY_SELECTED_SECURITY_ITEMS',
  TRANSFER_SECURITY_INCREMENT_SELECTED_SECURITY: 'TRANSFER_SECURITY_INCREMENT_SELECTED_SECURITY',
  TRANSFER_SECURITY_REMOVE_ITEM: 'TRANSFER_SECURITY_REMOVE_ITEM',
  TRANSFER_SECURITY_CLEAR: 'TRANSFER_SECURITY_CLEAR',
  TRANSFER_SECURITY_SELECT_SECURITY_CLEAR: 'TRANSFER_SECURITY_SELECT_SECURITY_CLEAR',
  TRANSFER_SECURITY_CLEAR_TRANSFERRED_ITEMS: 'TRANSFER_SECURITY_CLEAR_TRANSFERRED_ITEMS',
  TRANSFER_SECURITY_CLEAR_STORE: 'TRANSFER_SECURITY_CLEAR_STORE',

  RENT_ACCOUNT_CONTRACT_REQUEST: 'RENT_ACCOUNT_CONTRACT_REQUEST',
  RENT_ACCOUNT_CONTRACT_SUCCESS: 'RENT_ACCOUNT_CONTRACT_SUCCESS',
  RENT_ACCOUNT_CONTRACT_ERROR: 'RENT_ACCOUNT_CONTRACT_ERROR',

  MARGIN_ACCOUNT_CONTRACT_REQUEST: 'MARGIN_ACCOUNT_CONTRACT_REQUEST',
  MARGIN_ACCOUNT_CONTRACT_SUCCESS: 'MARGIN_ACCOUNT_CONTRACT_SUCCESS',
  MARGIN_ACCOUNT_CONTRACT_ERROR: 'MARGIN_ACCOUNT_CONTRACT_ERROR',

  SEND_TRANSFER_SECURITY_REQUEST: 'SEND_TRANSFER_SECURITY_REQUEST',
  SEND_TRANSFER_SECURITY_SUCCESS: 'SEND_TRANSFER_SECURITY_SUCCESS',
  SEND_TRANSFER_SECURITY_ERROR: 'SEND_TRANSFER_SECURITY_ERROR'
}

const parseSecurities = (securities = []) =>
  securities.map(item => ({
    ...item,
    key: item.securityName,
    value: item.securityName
  }))

const getTransferSecuritySuccess = (state, { data }) => {
  const newState = {
    ...state,
    isFetching: false,
    isFetched: true,
    success: true,
    data
  }
  const { accounts } = data.origin || {}
  newState.origin = accounts.map(item => ({
    key: item.type.type,
    value: item.type.description,
    accountType: item.type.type,
    accountNumber: item.accountNumber,
    securities: parseSecurities(item.securities)
  }))
  return newState
}

const removeSelectedSecurityTransferItem = (state, payload) => {
  const securityTransferItems = state.securityTransferItems.filter(
    securityTransferItem => securityTransferItem.key !== payload
  )
  const newState = {
    ...state,
    securityTransferItems
  }
  return newState
}

const getSelectedSecurityItems = (state, payload) => {
  const newState = {
    ...state,
    securityTransferItems: [...state.securityTransferItems, payload]
  }
  return newState
}

const setNewSecurityQuantity = (state, payload) => {
  const newSecurityTransferItems = state.securityTransferItems.map(security => {
    if (security.key === payload.key) {
      return {
        ...security,
        quantity: payload.newQuantity
      }
    }
    return security
  })

  const newState = {
    ...state,
    securityTransferItems: newSecurityTransferItems
  }
  return newState
}

const getItemSelection = (state, payload) => {
  const newState = { ...state, selectedOrigin: payload }

  const destination = newState.data.destination.filter(({ accountType }) => {
    if (payload.key !== accountType && (accountType === '1' || accountType === 'TD')) {
      return true
    }
    return false
  })

  newState.destination = destination.map(item => ({
    key: item.accountType,
    value: item.accountDescription
  }))

  return newState
}

export const getTransferSecurity = () => ({
  type: ACTION_TYPES.TRANSFER_SECURITY_REQUEST
})

export const setItemOrigin = payload => ({
  type: ACTION_TYPES.TRANSFER_SECURITY_SELECT_ORIGIN,
  payload
})

export const setItemDest = payload => ({
  type: ACTION_TYPES.TRANSFER_SECURITY_SELECT_DEST,
  payload
})

export const setItemSecurity = payload => ({
  type: ACTION_TYPES.TRANSFER_SECURITY_SELECT_SECURITY,
  payload
})

export const setQuantitySecurity = payload => ({
  type: ACTION_TYPES.TRANSFER_SECURITY_SELECT_QUANTITY_SECURITY,
  payload
})

export const setSelectedSecurityItems = payload => ({
  type: ACTION_TYPES.TRANSFER_SECURITY_SELECTED_SECURITY_ITEMS,
  payload
})

export const incrementSelectedSecurity = (key, newQuantity) => ({
  type: ACTION_TYPES.TRANSFER_SECURITY_INCREMENT_SELECTED_SECURITY,
  payload: { key, newQuantity }
})

export const removeSecurityTransferItem = payload => ({
  type: ACTION_TYPES.TRANSFER_SECURITY_REMOVE_ITEM,
  payload
})

export const clear = () => ({
  type: ACTION_TYPES.TRANSFER_SECURITY_CLEAR
})

export const clearSelectedSecurity = () => ({
  type: ACTION_TYPES.TRANSFER_SECURITY_SELECT_SECURITY_CLEAR
})

export const clearTransferredItems = () => ({
  type: ACTION_TYPES.TRANSFER_SECURITY_CLEAR_TRANSFERRED_ITEMS
})

export const getRentAccountContract = () => ({
  type: ACTION_TYPES.RENT_ACCOUNT_CONTRACT_REQUEST
})

export const getMarginAccountContract = () => ({
  type: ACTION_TYPES.MARGIN_ACCOUNT_CONTRACT_REQUEST
})

export const setTransferSecurity = payload => ({
  type: ACTION_TYPES.SEND_TRANSFER_SECURITY_REQUEST,
  payload
})

export const clearTransferSecurityStore = () => ({
  type: ACTION_TYPES.TRANSFER_SECURITY_CLEAR_STORE
})

const transferSecurity = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.TRANSFER_SECURITY_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case ACTION_TYPES.TRANSFER_SECURITY_SUCCESS:
      return getTransferSecuritySuccess(state, action.payload)
    case ACTION_TYPES.TRANSFER_SECURITY_ERROR:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        error: true,
        data: action.payload
      }
    case ACTION_TYPES.RENT_ACCOUNT_CONTRACT_REQUEST:
      return {
        ...state
      }
    case ACTION_TYPES.RENT_ACCOUNT_CONTRACT_SUCCESS:
      return {
        ...state,
        success: true,
        rentContract: action.payload.rentContract
      }
    case ACTION_TYPES.RENT_ACCOUNT_CONTRACT_ERROR:
      return {
        ...state,
        error: true,
        data: action.payload
      }

    case ACTION_TYPES.MARGIN_ACCOUNT_CONTRACT_REQUEST:
      return {
        ...state
      }
    case ACTION_TYPES.MARGIN_ACCOUNT_CONTRACT_SUCCESS:
      return {
        ...state,
        success: true,
        marginContract: action.payload.marginContract
      }
    case ACTION_TYPES.MARGIN_ACCOUNT_CONTRACT_ERROR:
      return {
        ...state,
        error: true,
        data: action.payload
      }

    case ACTION_TYPES.TRANSFER_SECURITY_SELECT_ORIGIN:
      return getItemSelection(state, action.payload)

    case ACTION_TYPES.TRANSFER_SECURITY_SELECT_DEST:
      return { ...state, selectedDest: action.payload }

    case ACTION_TYPES.TRANSFER_SECURITY_SELECT_SECURITY:
      return { ...state, selectedSecurity: action.payload }

    case ACTION_TYPES.TRANSFER_SECURITY_SELECT_QUANTITY_SECURITY:
      return { ...state, selectedQuantitySecurity: action.payload }

    case ACTION_TYPES.TRANSFER_SECURITY_SELECTED_SECURITY_ITEMS:
      return getSelectedSecurityItems(state, action.payload)

    case ACTION_TYPES.TRANSFER_SECURITY_INCREMENT_SELECTED_SECURITY:
      return setNewSecurityQuantity(state, action.payload)

    case ACTION_TYPES.TRANSFER_SECURITY_REMOVE_ITEM:
      return removeSelectedSecurityTransferItem(state, action.payload)

    case ACTION_TYPES.TRANSFER_SECURITY_CLEAR_TRANSFERRED_ITEMS:
      return {
        ...state,
        securityTransferItems: []
      }
    case ACTION_TYPES.TRANSFER_SECURITY_CLEAR:
      return {
        ...state,
        destination: [],
        selectedOrigin: null,
        selectedDest: null
      }
    case ACTION_TYPES.TRANSFER_SECURITY_SELECT_SECURITY_CLEAR:
      return {
        ...state,
        selectedSecurity: {
          avaliableQuantity: 0,
          inAnaliseQuantity: 0,
          key: '',
          securityId: '',
          securityName: '',
          securityValue: 0,
          unitPrice: 0,
          value: ''
        },
        selectedQuantitySecurity: 0
      }
    case ACTION_TYPES.SEND_TRANSFER_SECURITY_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case ACTION_TYPES.SEND_TRANSFER_SECURITY_SUCCESS:
      return {
        ...initialState,
        isFetching: false,
        isFetched: true,
        success: true
      }
    case ACTION_TYPES.SEND_TRANSFER_SECURITY_ERROR:
      return {
        ...initialState,
        isFetching: false,
        isFetched: true,
        error: true,
        data: action.payload
      }
    case ACTION_TYPES.TRANSFER_SECURITY_CLEAR_STORE:
      return initialState
    default:
      return state
  }
}

export default transferSecurity
